import random from 'toxilibs/random.js'
import Level from '../core/level.js'

const level = new Level({
    name: 'int_squared',
    dependencies: []
})


level.addQuestion({
    generator: function (q) {
        let a = random.fairChoice([2, 3, 4, 5, 6, 7, 10])
        q.addText('carre(' + a + ')')
        q.answer = a * a
    }
})


level.addQuestion({
    generator: function (q) {
        let a = -random.fairChoice([1, 2, 3, 4, 5, 6, 7, 10])
        q.addText('carre(' + a + ')')
        q.answer = a * a
    }
})


level.addQuestion({
    generator: function (q) {
        let a = random.fairChoice([0, 1, 2, 3, 4, 5, 6, 7, 10])
        let b = random.intBetween(1, 3)
        q.addText('carre(' + a + ') + ' + b)
        q.answer = a * a + b
    },
    times: 2
})





export default level

